export default __webpack_public_path__ + "static/media/pana.3a4cd7b3.svg";